module.exports = __webpack_public_path__ + "img/main_3.0b7c222a.png";